<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit }"
    slim
  >
    <div class="container-fluid">
      <form
        name="vm.campaignBasicDetailsForm"
        class="form-horizontal col-sm-12"
        @submit.prevent="handleSubmit(onSubmit)"
      >
        <Field
          :label="$t('CAMPAIGN_CREATE_FORM_NAME_LABEL')"
          :has-tooltip="true"
          :tooltip-text="$t('CAMPAIGN_CREATE_FORM_NAME_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="campaign_name"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-5 col-md-4">
                  <input
                    id="campaignNameInput"
                    v-model="campaignName"
                    type="text"
                    name="campaign_name"
                    autocomplete="off"
                    class="form-control"
                    :placeholder="$t('CAMPAIGN_CREATE_FORM_NAME_PH')"
                  >
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>

        <Field
          :label="$t('CAMPAIGN_CREATE_FORM_COUNTRY_LABEL')"
          :has-tooltip="true"
          :tooltip-text="$t('CAMPAIGN_CREATE_FORM_COUNTRY_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="country"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-5 col-md-4">
                  <input
                    id="country"
                    :value="countryName"
                    type="hidden"
                    name="country"
                  >
                  <CountrySelector
                    v-model="countryValue"
                    :placeholder="$t('CAMPAIGN_CREATE_FORM_COUNTRY_DEFAULT')"
                    name="country_selector"
                  />
                  <div
                    v-if="isContactSupport"
                    v-t="'CAMPAIGN_CREATE_SUPPORT_MESSAGE'"
                    class="bs-callout bs-callout-sm bs-callout-warning"
                  />
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>

        <div class="form-group">
          <div class="col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3">
            <PrimaryButton
              size="sm"
              :show-loader-on-form="showLoader"
            >
              <span v-t="'CREATE'" />
            </PrimaryButton>

            <button
              v-t="'CANCEL'"
              class="btn btn-sm btn-danger m-l-15"
              @click="cancel"
            />
          </div>
        </div>
      </form>
    </div>
  </ValidationObserver>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import CountrySelector from '@/core/components/CountrySelector/CountrySelector.vue';

export default {
  components: { CountrySelector },
  props: {
    showLoader: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => {
    return {
      campaignName: '',
      countryName: '',
      countryCode: '',
    };
  },
  computed: {
    countryValue: {
      get() {
        const label = this.countryName;
        const value = this.countryCode;

        if (!label || !value) {
          return null;
        }

        return {
          label,
          value,
        };
      },
      set({ label, value }) {
        this.countryName = label;
        this.countryCode = value;
      },
    },
    isContactSupport() {
      return this.countryValue && this.countryValue?.value !== 'US' && this.countryValue?.value !== 'CA';
    },
  },
  methods: {
    onSubmit() {
      const { campaignName, countryCode } = this;
      this.$emit('save', { name: campaignName, countryCode });
    },
    cancel() {
      this.$emit('dismiss');
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>